module.exports = __webpack_public_path__ + "img/fps-fiber.4803b92b.png";